'use strict';

module.exports = (selectedTraits, imageTraits) => {
  let match = true;
  for (const traitName in selectedTraits) {
    const traitValue = selectedTraits[traitName];
    if (
      !imageTraits[traitName] ||
      !imageTraits[traitName].includes(traitValue)
    ) {
      match = false;
      break;
    }
  }
  return match;
};
